/**
 * Can this device play? The game needs a mouse (right-click pushes, hold opens a nation's menu)
 * and keys (1–7 build, Q/E/R/F orders), so phones and touch-only tablets get a "desktop needed"
 * screen instead of the game. An iPad or a touch laptop with a trackpad / mouse attached
 * (`any-pointer: fine`) plays.
 */

/** A phone by its user agent (whatever its pointer claims). */
const PHONE_UA = /iPhone|iPod|Android.+Mobile|Windows Phone|webOS|BlackBerry|Opera Mini|IEMobile/i;

export interface DeviceProbe {
  ua: string;
  /** `matchMedia(query).matches` */
  media(query: string): boolean;
}

function browserProbe(): DeviceProbe {
  return {
    ua: typeof navigator === 'undefined' ? '' : navigator.userAgent,
    media: (q) => (typeof matchMedia === 'function' ? matchMedia(q).matches : false),
  };
}

/** A phone, or a device whose only pointer is a finger. */
export function touchOnly(p: DeviceProbe = browserProbe()): boolean {
  if (PHONE_UA.test(p.ua)) return true;
  return p.media('(pointer: coarse)') && !p.media('(any-pointer: fine)');
}
